module.exports = __webpack_public_path__ + "797bb3689f2760bfdd192ee58b815d7d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/log.svg
// module id = 9RlG
// module chunks = 102